import { render, staticRenderFns } from "./BInputPassword.vue?vue&type=template&id=1f9667d6&"
import script from "./BInputPassword.vue?vue&type=script&lang=js&"
export * from "./BInputPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports